// extracted by mini-css-extract-plugin
export default {"container":"AcceptedCurrenciesField_container__XfftE","icon":"AcceptedCurrenciesField_icon__rd5vf"};